<template>
    <div :class="['field field--select']">
        <div>
            <label
                :for="id"
                class="title bold static-label"
            >
                {{ label }}
            </label>
            <div class="field--select__input">
                <i class="i-chevron-down" />
                <select
                    :id="id"
                    rows="10"
                    :value="value"
                    @change="emitInput($event)"
                    :required="required"
                >
                    <option
                        :value="null"
                        disabled
                        selected
                        class="placeholder"
                        v-if="placeholder">{{ placeholder }}</option>
                    <option
                        v-for="(option, index) in options"
                        :key="`option-${index}`"
                        :value="option.value">{{ option.name }}</option>
                </select>
            </div>
        </div>
        <small
            v-if="errors.length"
            v-html="errors.join('<br/>\n')"
            class="text-danger"></small>
        <small v-else-if="hint">{{ hint }}</small>
    </div>
</template>

<script>
    export default {
        name: 'CoreSelect',
        data() {
            return {
                error: false,
                type: null
            }
        },
        props: {
            id: {
                type: String,
                default() { return `text-input-${this._uid}`}
            },
            label: {
                type: String,
                default: ''
            },
            options: {
                type: Array,
                default() {
                    return [
                        { value: true, name: 'Ja' },
                        { value: false, name: 'Nee' }
                    ]
                }
              },
            hint: {
                type: String,
                default: ''
            },
            placeholder: {
                type: String,
                defualt: ''
            },
            value : {
                required: false,
                default: ''
            },
            required: {
                type: Boolean,
                default: false
            },
            errors: {
                type: Array,
                default: () => []
            }
        },
        methods: {
            emitInput($event) {
                var value = $event.target.value
                if(value === 'true') {
                    value = true
                } else if (value === 'false') {
                    value = false
                }
                this.$emit('input', value)
            }
        }
    }
</script>

<style lang="scss" scoped>
.field--select {
    & > div {
        position: relative;
    }

    &__input {
        position: relative;

        i {
            position: absolute;
            top: 50%;
            right: 1rem;

            margin-top: -0.5rem;

            color: var(--secondary);
        }
    }

    .static-label {
        display: block;

        margin-bottom: 0.5rem;

        color: var(--text-dark);
    }

    select {
        display: inline-flex;
        // border: 1px solid var(--border-grey);

        width: 100%;
        padding: 1rem 3rem 1rem 1rem;

        border: none;
        border-radius: 4px;
        background-color: var(--bg-white);
        box-shadow: inset 0 0 0 1px  var(--border-grey-50);

        font-size: 1rem;

        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;

        &:focus {
            border-color: var(--border-grey-dark);
        }
    }

    small {
        display: block;

        margin-top: 0.5rem;

        &.text-danger {
            color: var(--system-red);
        }
    }
}
</style>
